import { BaseDTO } from '../global/base.dto';
import { ResourceListDTO } from '../resource/resource-list.dto';
import { UserListDTO } from '../user/user-list.dto';

export class QualificationDTO extends BaseDTO {

    name: string;

    description: string;

    users: Array<UserListDTO>;

    resources: Array<ResourceListDTO>;

}
